<div >
    <div #tref style="cursor: text; text-align: left; padding: 8px;" contenteditable="true" data-empty-test="add note here" class="note-placeholder" (input)="onNoteInput($event)" (blur)="onNoteChange($event)"></div>
</div>